import ApplicationController from "./application_controller";
import debounced from "debounced";
// ---------------- DEBOUNCED ---------------
// -- https://github.com/hopsoft/debounced --
// ------------------------------------------

export default class extends ApplicationController {
  static targets = ["editor"];

  connect() {
    super.connect();
    debounced.initialize();
  }

  toggle(e) {
    if (e.target.checked) {
      this.editorTarget.classList.remove("d-none");
    } else {
      this.editorTarget.classList.add("d-none");
    }
  }
}
